import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import userService from "@/endpoints/userService";
import ModalWithoutHeaderAndFooterAtCenter from "@/components/common/ModalWithoutHeaderAndFooterAtCenter/ModalWithoutHeaderAndFooterAtCenter";
import ModalHeader from "@/components/common/ModalWithoutHeaderAndFooter/components/ModalHeader/ModalHeader";
import ICONS from "@/constant/IconManager";
import { getFormattedValidationState, type ValidateViewsResponse } from "./utils";
import ValidationList from "./ValidationList";
import tokenManager from "@/utils/tokenManager";

const ValidateView = () => {
  const location = useLocation();
  const [validationResponse, setValidationResponse] = useState<ReturnType<
    typeof getFormattedValidationState
  >>(null);
  const [open, setOpen] = useState<boolean>(false);

  function handleClose() {
    setOpen(false);
  }

  useEffect(() => {
    const validate = async () => {
      const searchParams = new URLSearchParams(location.search);
      const viewId = searchParams.get("viewId");
      if (viewId) {
        try {
          const response = await userService.views.validateViews(viewId);
          const formattedResponse = getFormattedValidationState(
            response as ValidateViewsResponse,
          );
          if (formattedResponse) {
            setValidationResponse(formattedResponse);
            setOpen(true);
          }
        } catch (error) {
          console.error("Validation failed:", error);
        }
      }
    };
    const token = tokenManager.getToken();
    if (token && token?.length > 0) {
      validate();
    }
  }, []);

  return (
    <ModalWithoutHeaderAndFooterAtCenter open={open} onClose={handleClose}>
      <ModalHeader
        title={"Limited access"}
        subTitle={"You may not have access to certain entities."}
        onClose={handleClose}
        icon={
          <div className="bg-[#f1e6bf] rounded-[50%] p-[10px]">
            <img className="h-[22px]" src={ICONS.WARNING.yellow} alt="" />
          </div>
        }
      />
      <div className="p-6 pb-1 max-h-[480px] overflow-auto">
        <div className="text-base text-semibold text-text-300 mb-[12px]">
          Some details for the view are not applicable to your account.
        </div>
        {validationResponse?.brand && validationResponse.brand.length > 0 && (
          <ValidationList
            title="Following brands are no longer available"
            data={validationResponse.brand}
          />
        )}
        {validationResponse?.brandSet && validationResponse.brandSet.length > 0 && (
          <ValidationList
            title="Following brand sets contain brands that are no longer available"
            data={validationResponse.brandSet}
          />
        )}
        {validationResponse?.filter && validationResponse.filter.length > 0 && (
          <ValidationList
            title="Following filters are no longer available"
            data={validationResponse.filter}
          />
        )}
        {validationResponse?.segment && validationResponse.segment.length > 0 && (
          <ValidationList
            title="Following segments are no longer available"
            data={validationResponse.segment}
          />
        )}
      </div>
      <div className="py-2 pt-4 px-6 border-t border-neutral-200">
        <button
          onClick={handleClose}
          className="rounded-[2px] cursor-pointer bg-[#0062ff] w-full p-[14px] mb-2 text-semibold text-white transition hover:bg-[#004ecc]"
        >
          Understood
        </button>
      </div>
    </ModalWithoutHeaderAndFooterAtCenter>
  );
};

export default ValidateView;
